import { Pixall } from 'reaxl-analytics-handlers';

/**
 * @summary Handles AI Assistant entry point click on SRP banner
 */
export async function aiAssistantEntryPointClick({ data = {}, dataLayer }, option) {
    const {
        placement = 'srp-banner',
        url,
    } = data;

    // Pixall Analytics
    await Pixall.sendClickEvent({
        pageType: 'srp',
        eventSource: 'personalization',
        eventType: 'click',
        label: 'text-link::try-our-new-AI-shopping-assistant',
        url,
        placement,
    }, dataLayer, option);
}
